import { useEffect, useState, useRef } from "react";
import CloseIcon from "../../assets/icons/close-2hite.svg";
import DownloadIcon from "../../assets/icons/download_white.svg";
import ZoomInIcon from "../../assets/icons/zoom_in.svg";
import ZoomOutIcon from "../../assets/icons/zoom_out.svg";
import { Viewer } from "@react-pdf-viewer/core";
import { zoomPlugin } from "@react-pdf-viewer/zoom";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/zoom/lib/styles/index.css";
import "./FilePreviewModal.css";

const FilePreviewModal = ({ fileUrl, modalToggle, onClose }) => {
  const modalRef = useRef(null);

  // Render viewer only when modal is visible
  const [visible, setVisible] = useState(false);

  // Zoom control
  const zoomPluginInstance = zoomPlugin();
  const { zoomTo } = zoomPluginInstance;
  const [zoomLevel, setZoomLevel] = useState(1);

  const handleZoomIn = () => {
    const newZoom = Math.min(zoomLevel + 0.2, 3); // max 300%
    zoomTo(newZoom);
    setZoomLevel(newZoom);
  };

  const handleZoomOut = () => {
    const newZoom = Math.max(zoomLevel - 0.2, 0.5); // min 50%
    zoomTo(newZoom);
    setZoomLevel(newZoom);
  };

  // Show modal
  useEffect(() => {
    if (modalToggle && modalRef.current) {
      const modal = new window.bootstrap.Modal(modalRef.current);

      modalRef.current.addEventListener("shown.bs.modal", () => {
        setVisible(true); // render viewer only after modal displayed
      });

      modalRef.current.addEventListener("hidden.bs.modal", () => {
        setVisible(false);
        setZoomLevel(1); // reset zoom
      });

      modal.show();
    }
  }, [modalToggle]);

  return (
    <>
      {/* Modal */}
      <div
        className="modal fade"
        id="universalDocModal"
        tabIndex="-1"
        ref={modalRef}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-centered preview-modal position-relative">
          <div className="modal-content content-align">
            <div className="preview-modal-content">
              {/* Toolbar */}

              {/* Viewer Area */}
              <div
                className="modal-body flex justify-center items-center"
                style={{
                  height: "87vh",
                  overflow: "hidden",
                }}
              >
                <div style={{ width: "100%", height: "100%" }}>
                  {visible && (
                    <Viewer fileUrl={fileUrl} plugins={[zoomPluginInstance]} />
                  )}
                </div>
              </div>

              {/* Footer */}
              <div className="position-absolute preview-footer">
                <div
                  className="btn preview-close-btn"
                  data-bs-dismiss="modal"
                  onClick={onClose}
                >
                  <img src={CloseIcon} alt="Close" />
                </div>
              </div>
            </div>
            <div className="flex items-center mt-12">
              <div className="flex items-center">
                <div
                  className="preview-zoom-out"
                  onClick={handleZoomOut}
                  role="button"
                  title="Zoom out"
                  style={{ cursor: "pointer" }}
                >
                  <img className="preview-zoom-ico" src={ZoomOutIcon} alt="" />
                </div>
                <div
                  className="preview-zoom-in"
                  onClick={handleZoomIn}
                  role="button"
                  title="Zoom in"
                  style={{ cursor: "pointer" }}
                >
                  <img className="preview-zoom-ico" src={ZoomInIcon} alt="" />
                </div>
              </div>
              <a
                className="preview-btn-download"
                href={fileUrl}
                download
                style={{
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none",
                  color: "inherit",
                  cursor: "pointer",
                }}
              >
                <img
                  className="preview-btn-download-ico"
                  src={DownloadIcon}
                  alt=""
                />
                <div className="preview-btn-download-text">Download</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilePreviewModal;
